import { render, staticRenderFns } from "./DocenteEditarSalon.vue?vue&type=template&id=843bd85a&"
import script from "./DocenteEditarSalon.vue?vue&type=script&lang=js&"
export * from "./DocenteEditarSalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports